<template>
  <div class="content-table">
    <div class="content-row" style="margin-top:4%;margin-bottom:2%">
      <div class="col-4">
        <div class="col-3">代客下单:</div>
        <div class="div-right col-9" style="position: relative;">
          <img @click="pop()" src="/index/static/icon/sousuo.png" class="sousuo_icon" />
          <el-input placeholder="请输入内容" v-model="custom_name" readonly></el-input>
        </div>
      </div>
      <div style="display: inline-block;" class="col-8">
        <div class="col-7" style="text-align: right;
    line-height: 40px;">优惠码</div>
        <div class="col-3" style=" text-align: right;">
          <el-input v-model="promo_code" style="width:70%" class="discount_input"></el-input>
        </div>
        <div class="col-2" style=" text-align: right;">
          <el-button
            @click="purchase"
            style="background:rgba(207,149,93,1);font-size:14px;color:rgba(255,255,255,1);border:none"
          >立即购买</el-button>
        </div>
      </div>
    </div>
    <template>
      <template>
        <el-dialog :visible.sync="pop_goods.show" width="70%" title="商品" :show-close="false">
          <div class="content-row action-row">
            <div class="div-right" style="position: relative;width:60%;display: inline-block;">
              <img @click="choose_good()" src="/index/static/icon/sousuo.png" class="sousuo_icon" />
              <el-input placeholder="请输入内容" v-model="good_keyword"></el-input>
            </div>
            <el-button size="mini" @click="goods_sub()" style="margin-left: 6%;">确认</el-button>
            <el-button size="mini" @click="close_pop_goods()">返回</el-button>
          </div>
          <el-table
            :data="goods_datas"
            height="250"
            border
            style="width: 100%"
            @selection-change="selectCall"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column prop="good_code" label="商品代码" width="180"></el-table-column>
            <el-table-column prop="good_name" label="商品名称" width="180"></el-table-column>
            <el-table-column prop="good_cate_name" label="商品分类"></el-table-column>
            <el-table-column prop="good_spec" label="规格型号" width="180"></el-table-column>
            <el-table-column prop="unit_name" label="计量单位"></el-table-column>
            <el-table-column prop="mini_qty" label="起订量" width="180"></el-table-column>
            <el-table-column prop="price" label="销售价"></el-table-column>
          </el-table>
        </el-dialog>
      </template>
      <template>
        <el-dialog :visible.sync="billTime.show" title="客户" width="45%" :show-close="false">
          <div class="content-row action-row1">
            <div class="div-right" style="position: relative;width:60%;display: inline-block;">
              <img @click="pop()" src="/index/static/icon/sousuo.png" class="sousuo_icon" />
              <el-input placeholder="请输入内容" v-model="costom_keyword"></el-input>
            </div>
            <el-button size="mini" @click="selection()" style="margin-left: 6%;">确认</el-button>
            <el-button size="mini" @click="close_selection()">返回</el-button>
          </div>
          <el-table :data="staff_datas" border style="width: 100%" @selection-change="selectCall">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="custom_code" label="客户代码" width="180"></el-table-column>
            <el-table-column prop="custom_name" label="客户名称"></el-table-column>
          </el-table>
        </el-dialog>
      </template>
      <el-table
        :data="tableData"
        sortable
        show-summary
         :header-cell-style="this.$store.state.rowStyle" 
      >
        <el-table-column prop="good_code" label="商品代码"></el-table-column>
        <el-table-column prop="good_name" label="商品名称">
          <template slot-scope="scope">
            {{scope.row.good_name}}
            <span
              v-if="scope.row.good_name == null"
              @click="choose_good(scope.$index)"
              class
              style="position: absolute; top: 10px;right: 20px;cursor: pointer;"
            >
              <b style="font-size:16px">&middot;&middot;&middot;</b>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="good_cate_name" label="商品分类"></el-table-column>
        <el-table-column prop="good_spec" label="规格型号"></el-table-column>
        <el-table-column prop="batch" label="属性"></el-table-column>
        <el-table-column prop="unit_name" label="计量单位"></el-table-column>
        <el-table-column prop="mini_qty" label="起订量"></el-table-column>
        <!-- <el-table-column prop="a_price" label="销售价"></el-table-column> -->
        <el-table-column prop="cheap_money" label="购买数量">
          <template slot-scope="scope">
            <el-input
              v-model="tableData[scope.$index].cheap_money"
              class="onblur"
              @blur="text(scope.$index,scope.row)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="单价"></el-table-column>
        <el-table-column prop="vprice" label="直销价">
          <template slot-scope="scope">
            <el-input v-model="scope.row.vprice" class="onblur"></el-input>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <img
              src="/index/static/icon/add_row.png"
              @click="add_tr(scope.$index)"
              style="width: 20px;"
            />
            <img
              src="/index/static/icon/del_row.png"
              @click="remove_tr(scope.$index,scope.row)"
              style="width: 20px;"
            />
          </template>
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>
<script>
var total_row = [];
export default {
  name: "",
  components: {},
  data() {
    return {
      data: [],
      rowStyle: {
        color: "#fff",
        background: "#52a6ee"
      },
      total: 0,
      pagesize: 10,
      detailes: "",
      row: [],
      sums: "0.00",
      discount: "",
      info: "",

      tableData: [{}],
      pop_goods: {
        show: false
      },
      billTime: {
        show: false
      },
      row: "",
      goods_datas: [],
      staff_datas: [],
      project_name: "",
      // staff_name: "",
      operator: "",
      remarks: "",
      promo_code: "",
      custom_name: "",
      custom_erpid: "",
      index: "",
      good_keyword: "",
      costom_keyword: ""
    };
  },
  mounted() {
    this.view();
  },
  watch: {
    currentPage(oldV, newV) {
      
    },
    page: "view",
    pagesize: "view"
  },
  methods: {
    view() {
      var id = this.$route.query.id;
      this.$axios({
        method: "post",
        url: "/index/contract/detail",
        params: {
          id: id
        }
      })
        .then(res => {
          this.data = res.data.data.goods;
          this.info = res.data.data.info;
          
        })
        .catch(err => {
          this.$message(err);
        });
    },
    add_tr(i) {
      
      // this.tableData.push({});
      this.tableData.splice(i + 1, 0, "");
      
    },
    remove_tr(d) {
      if (this.tableData.length == 1) {
        this.$message1("已经是最后一行了");
        return false;
      } else {
        this.tableData.splice(d, 1);
      }
    },
    selectCall(row) {
      this.row = row;
    },
    // 客户弹窗
    pop() {
      this.billTime.show = true;
      this.$axios({
        method: "post",
        url: "/index/personal/auth_custom",
        params: {
          keyword: this.costom_keyword
        }
      })
        .then(res => {
          this.staff_datas = res.data.data.data;
        })
        .catch(err => {});
    },
    selection() {
      if (this.row.length != 1) {
        this.$message1("请选择一条客户信息");
      } else {
        this.custom_erpid = this.row[0].custom_erpid;
        this.custom_name = this.row[0].custom_name;
        // this.custom_code = this.row[0].custom_code;
        // this.staff_erpid = this.row[0].staff_erpid;
        // this.staff_name = this.row[0].staff_name;
        this.billTime.show = false;
        this.costom_keyword = "";
      }
    },
    close_selection() {
      this.billTime.show = false;
      this.costom_keyword = "";
    },
    //商品弹窗

    choose_good(i) {
      this.index = i;
      this.pop_goods.show = true;
      this.$axios({
        method: "post",
        url: "/index/catalogue/good_sku",
        params: {
          keyword: this.good_keyword
        }
      })
        .then(res => {
          this.goods_datas = res.data.data.data;
        })
        .catch(err => {});
    },
    goods_sub() {
      for (let i = 0; i < this.row.length; i++) {
        var p = this.row[i]["a_price"];
        this.row[i]["aprice"] = p;
      }
      for (let i = 0; i < this.row.length; i++) {
        this.tableData.splice(this.index + 1, 0, this.row[i]);
      }
      for (let i = 0; i < this.tableData.length; i++) {
        if (
          JSON.stringify(this.tableData[i]) == "{}" ||
          this.tableData[i] == ""
        ) {
          this.tableData.splice(i, 1);
        }
      }

      var temp = {};
      this.tableData = this.tableData.reduce((prev, curv) => {
        // 如果临时对象中有这个名字，什么都不做
        if (temp[curv.sku_good_code]) {
        }
        // 如果临时对象没有就把这个名字加进去，同时把当前的这个对象加入到prev中
        else {
          temp[curv.sku_good_code] = true;
          prev.push(curv);
        }
        return prev;
      }, []);

      this.pop_goods.show = false;
      this.good_keyword = "";
    },
    close_pop_goods() {
      this.pop_goods.show = false;
      this.good_keyword = "";
    },
    purchase() {
      var data = [];
      for (let i = 0; i < this.tableData.length; i++) {
        data.push({
          code: this.tableData[i].sku_good_code,
          qty: this.tableData[i].cheap_money,
          price: this.tableData[i].vprice
        });
      }
      for (let i = 0; i < this.tableData.length; i++) {
        if (JSON.stringify(this.tableData[i]) != "{}") {
          this.$axios({
            method: "post",
            url: "/index/cart/check_replace",
            params: {
              goods: data,
              promo_code: this.promo_code,
              c_id: this.custom_erpid
            }
          })
            .then(res => {
              this.$message1(res.data.msg);
              if (res.data.status == "ok") {
                this.$router.push({
                  path: "/Cart/order",
                  query: { code: this.promo_code, value: "XSO" }
                });
              }
            })
            .catch(err => {});
        } else {
          this.$message1("请选择商品");
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.col-3 {
  line-height: 44px;
  padding-right: 1%;
  width: 23.999%;
  font-size: 14px;
}
.sousuo_icon {
  position: absolute;
  z-index: 111;
  top: 28%;
  right: 10%;
  cursor: pointer;
}
.textarea {
  width: 99%;
  resize: none;
  height: 68px;
  border: 1px solid rgba(187, 187, 187, 1);
}
.discount_row {
  margin-top: 4%;
  text-align: right;
  margin-bottom: 2%;
}
.discount {
  width: 55%;
}
.table_scroll ::-webkit-scrollbar {
  width: 0px; /*滚动条宽度*/
  height: 5px; /*滚动条高度*/
  background-color: white;
  margin-right: 10px;
}
.onblur {
  border: none;
}

/*定义滑块 内阴影+圆角*/
.table_scroll ::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px #f5f7fa;
  background-color: rgba(221, 222, 224); /*滚动条的背景颜色*/
}
.el-table__fixed-right-patch {
  width: 0px; /*滚动条宽度*/
}
</style>
<style lang="less">
.el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #606266;
}
.onblur input {
  border: none;
}
.action-row {
  width: 40%;
  float: right;
  margin: -3.5% 4% 0 0;
}
.action-row1 {
  width: 55%;
  float: right;
  margin: -7.5% 4% 0 0;
}
</style>
<style lang="less" >
.discount_input input {
  background: rgba(238, 238, 238, 1);
}
.heade .el-dialog__header {
  height: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Valet_order/index.vue